const lan = {
  REDIRECT: "Omdirigerer...",
  RULE: {
    SERVICE_TYPE: "Vennligst velg tjenestetype",
    COUNTRY: "Velg ditt land eller din region",
    USERNAME: "Et brukernavn er påkrevd",
    EMAIL: "En e-postadresse er påkrevd",
    EMAIL2: "Vennligst skriv inn riktig e-postformat.",
    PRODUCT: "Velg din enhet",
    PRODUCTSN: "Skriv inn produktets serienummer",
    PRODUCTSN_LEN: "Skriv inn 12 til 15 bokstaver eller tall",
    BIRTHDAY: "En fødselsdag er påkrevd",
    REQUIRED: "Påkrevd",
  },
  SYS: {
    HEAD: "System",
    NOSERVICE:
      "Beklager, ASUS Chat for ditt valgte land eller område er ikke tilgjengelig.",
    CHECK_FILESIZE:
      "Kontroller størrelsen på bildet eller vedlegget. Begrensning:",
    RECONNECTED: "Tilkoblingsstatusen har gått tilbake til normal",
    UNABLE_SEND: "Kan ikke sende vedleggene",
    NO_NETWORK: "Ingen internettilkobling",
    NO_NETWORK_INFO:
      "Ingen internettilkobling. Koble til internett og prøv igjen.",
  },
  IDLE: {
    HEAD: "Du har vært inaktiv en stund. Vil du fortsette chatten?",
    BUTTON: "Fortsett",
  },
  DISCONNECT: {
    HEAD: "Chatten er avsluttet",
    BUTTON: "Avslutt",
  },
  LAYOUT: {
    STEP_1: "Velg produkt",
    STEP_2: "Vilkår for bruk",
    STEP_3: "Logg inn",
    STEP_4: "Informasjon",
    SELECT_SKILL: "Velg produkt",
    PREV_STEP: "Forrige",
    NEXT_STEP: "Neste",
    NOTSET: "Ikke angitt.",
    AGREEN: "Godtar",
    NOTAGREEN: "Godtar ikke",
    LEAVE: "Forlat",
    TYPE_HERE: "Skriv her",
    CHAT_DOWNLOAD:
      "Klikk her for å lagre en kopi av din chat med ASUS kundeservice.",
  },
  COUNTRY: { SELECT_COUNTRY: "Vennligst velg tjenestens land eller region" },
  POLICY: {
    PRIVACY: "Personvernpolicy",
    SAT_SURVEY: "Serviceavtale",
    CONFIRM_COUNTRY: {
      H1: "Kjære ASUS-kunde,",
      P1:
        "Du besøker nå ASUS Kundeservice for Norden, som er forskjellig fra din nåværende region. I henhold til ASUS' garantivilkår er ikke alle ASUS-produkter kvalifisert for ASUS' internasjonale garanti- og støttetjenester. Hvis den regionale nettsiden du besøker ikke er regionen der du kjøpte ditt ASUS-produkt eller er forskjellig fra din nåværende region, kan dette påvirke dine rettigheter. Du kan fortsette å bruke ASUS' online kundeservice for Norge eller endre ASUS' online kundeservice til din region.",
      P2: "",
      P3: "",
      B1: "Bytt til ASUS",
      B2: "Hjemmeside",
      B3: "Fortsett å bruke",
    },
    BULLETIN: {
      HEAD: "Varsel om en viktig melding",
      CONFIRM: "Jeg forstår",
    },
  },
  SURVEY: {
    SURVEY_ENTER: "Vennligst fyll inn dine kontaktopplysninger",
    SURVEY_TYPE: "Vennligst velg tjenestetype",
    PROBLEM_BRIEF: "Hvordan vil du beskrive ditt problem?",
    TYPE1: "Generell henvendelse",
    TYPE2: "Reparasjonsforespørsel",
    TYPE3: "Teknisk støtte",
    TYPE4: "Garantiforespørsel",
    TYPE5: "Tilbakemeldinger og meninger",
    EC_TYPE1: "Produkt- og salgsinformasjon",
    EC_TYPE2: "Markedsføringshendelse",
    EC_TYPE3: "Frakt- og ordrestatus",
    EC_TYPE4: "Returtjeneste",
    SIGNUPDATA: "Din registreringsinformasjon",
    NAME: "Navn",
    TEL: "Telefonnummer",
    ORDER_NO: "Ordrenr.",
    BIRTHDAY: "Fødselsdag",
    LABEL_EMAIL: "E-post",
    EMAIL: "E-post",
    DEVICEINFO: "Din produktinformasjon",
    DEVICENAME: "Produktnavn",
    MY_DEVICE: "Ditt produkt",
    MY_DEVICE_SELECT: "Velg ditt produkt",
    MY_DEVICE_EMPTY: "Du har ingen enheter ennå.",
    LABEL_DEVICESN: "Serienummer",
    DEVICESN: "Produktets serienummer",
    DEVICESN_ERROR: "Serienummeret du skrev inn er ugyldig.",
    PREPARE: "Oppretter chatterommet, gjør klar til å chatte",
    START: "Start chatten",
    AGE_LIMIT: "Aldersgrense",
    AGE_LIMIT_DESC: "Du oppfyller ikke alderskravene for å bruke ASUS Chat",
    REPEAT_ENTRY: {
      H1: "Eksisterende chatterom oppdaget",
      P1:
        "Er du sikker på at du vil starte en ny samtale? Når en ny samtale åpnes, vil den gamle samtalen avsluttes.",
      B0: "Bekreft",
      B1: "Avbryt",
    },
  },
  CONNECTTING: {
    P1: "Vennligst vent et øyeblikk, og ikke lukk chattevinduet",
    P2: "ASUS Chat kobler deg til en tilgjengelig agent",
    NOTE: "Hint",
    BEFORE_LEAVE: "Er du sikker på at du vil avslutte din ASUS Chat?",
    B0: "Fullfør",
    B1: "Bli og vent",
  },
  OFFLIEN: {
    OTHER_CONTACT: "Kontakt ASUS via andre kanaler",
    MAIL: "Send oss en e-post",
    TEL: "Ring oss",
    CLOSE: "Lukk",
  },
  WAITTING: {
    WATTING_NUM: "Posisjon i køen",
    PEOPLE: "Kunde",
    NOTE: "Hint",
    BEFORE_LEAVEL: "Er du sikker på at du vil forlate køen?",
    LEAVE_DESC: "Hvis du vil forlate køen, kan du avslutte chatten",
    LEAVE: "Avslutt chatten",
    STAY: "Bli i køen",
  },
  CHATROOM: {
    TYPING: "Agenten skriver...",
    HEAD: {
      CLOSE_AMD_SURVEY: "Forlat chatten",
      TERMINATE: "Avslutt chatten",
    },
    FOOTER: { CHAT_FINISH: "Chatten er avsluttet" },
    FINISH:
      "Chatten er avsluttet. Trenger du ytterligere service eller støtte?",
    SAT_SURVEY: {
      SAT: "Fornøyd",
      DISSAT: "Misfornøyd",
      SAT_CHOOSE: "Hvilken type tjenester? (flere)",
      HEAD: "Var du fornøyd med chatten?",
      DESC:
        "Å lytte til dine tilbakemeldinger er en drivkraft for vår kontinuerlige forbedring. Vennligst gi oss beskjed hvis du har noen forslag til ASUS Service eller Support.",
      OTHER_OPTION: "Annet",
      OTHER_REASON: "Vennligst fyll inn den andre årsaken",
      SEND: "Send",
    },
    CLOSE: {
      TITLE: "Er du sikker på at du vil avslutte chatten?",
      P1:
        'Klikk "Fullfør" for å lukke vinduet. Hvis du trenger å bruke chatten igjen, vennligst klikk "Start ny chat".',
      B0: "Fullfør",
      B1: "Avbryt",
    },
  },
  ERROR: {
    H1: "Chatterommet eksisterer ikke eller chatten er allerede avsluttet",
    CLOSE: "Lukk vinduet",
  },
  CHAT_END: {
    H1: "Tusen takk, chatten er nå avsluttet",
    CLOSE: "Lukk vinduet",
  },
  CHAT_CLOSE: {
    H1:
      "Nettverket ditt har vært nede i mer enn 300 sekunder, så vi har avsluttet denne samtalen.",
    DESC:
      "Hvis du bruker et trådløst eller et mobilt nettverk, vennligst flytt deg til et sted med et sterkere signal; eller bytt til en kablet nettverkstilkobling. Vi beklager eventuelle ulemper",
    CLOSE: "Lukk vinduet",
  },
  SURVEY_DONE: {
    H1: "Takk. Du har fullført undersøkelsen om servicetilfredshet",
    P1:
      'Dine tilbakemeldinger er en drivkraft for vår kontinuerlige forbedring. Takk for at du tok deg tid til å fullføre undersøkelsen om servicetilfredshet. Hvis du trenger ytterligere service eller støtte, vennligst klikk "Start ny chat". Vennligst klikk "Lukk vinduet" for å avslutte chatten hvis vi har løst din henvendelse',
    AGAIN: "Start ny chat",
    CLOSE: "Lukk vinduet",
    YT_H1: "Oppdag tips og teknisk kunnskap med ASUS' støttevideoer.",
    YT_H2: "Klikk for å utforske!",
  },
  AGENT_OFFLINE: {
    H1:
      "Internettforbindelsen til agenten svarer ikke; chatten din er for øyeblikket avbrutt",
    H2:
      "Vennligst ikke lukk vinduet; vi jobber hardt for å gjenoppta chatten",
    DESC:
      'Du kan også velge å avslutte chatten og begynne undersøkelsen eller klikke "Start ny chat", og vi vil umiddelbart tildele en ny agent for å fortsette chatten din. Vi beklager eventuelle ulemper',
    AGAIN: "Start ny chat",
  },
  VIDEOCALL: {
    MEDIA_NOTALLOW: "Kan ikke bruke kamera og mikrofon",
    H1: "Klar til å bli med?",
    P1:
      "For at ASUS' kundeservicepersonell skal kunne hjelpe deg med å løse problemet mer effektivt, må du tillate enheten å få tilgang til kameraet og mikrofonen din for å bli med i videochatterommet, og vennligst sørg for at din mobile nettverkstilkobling er stabil og fungerer normalt",
    P2:
      "Etter å ha fått tilgang, kan du fortsatt fritt stille inn linsebryteren og mikrofonen på lydløs.",
    VIDEO_STATE: "Videostatus",
    VIDEO_ON: "På",
    VIDEO_OFF: "Av",
    AUDIO_STATE: "Lydstatus",
    AUDIO_ON: "På",
    AUDIO_OFF: "Av",
    ENTER: "Bli med",
    HANGUP: {
      H1: "Legg på",
      P1: "Er du sikker på at du vil legge på videochatten?",
      CONFIRM: "Bekreft",
      CANCEL: "Avbryt",
    },
    END: {
      H1: "Videosamtalen er avsluttet",
      P1: "Takk, denne videosamtalen er over, du kan lukke dette vinduet.",
    },
  },
  GPT: {
    LAYOUT: {
      STEP_1: "Velg produkt",
      STEP_2: "Vilkår for bruk",
      STEP_3: "Logg inn",
      STEP_4: "Informasjon",
      SELECT_SKILL: "Velg produkt",
      WELCOME: "Velkommen",
      AGREE: "Godta",
      START: "Start",
      CANCEL: "Avbryt",
      WAIT: "Vennligst vent",
      INPUT: "Skriv inn spørsmålet ditt her",
      TRANSFER_TOAGENT: "Overfør til agent.",
      READMORE: "Du kan også se følgende relaterte FAQ, takk.",
      COLLAPSE: "Skjul",
      INPUT_SN: "Vennligst skriv inn serienummeret på nytt",
      YOU_MAY_ALSO: "Du kan også spørre:",
      FOR_FURTHER: "For mer informasjon, vennligst se:",
    RECORDING: "Vennligst begynn å snakke...",
      RECORDING_NOT_SUPPORTED:
        "Nettleseren din støtter ikke talegjenkjenning",
      RECORDING_NOT_FOUND:
        "Ingen opptaksenhet oppdaget. Vennligst sjekk mikrofonen og tillatelsene dine.",
},
    IS_COMPONENT_SN: "Inndataene er komponentens serienummer, du bør skrive inn riktig maskinens serienummer.",
WARRANTY: {
      SERIES: "Produkttype",
      MODEL: "Produktnavn",
      SERIALNO: "Produktets serienummer",
      STATUS: "Garantistatus",
      DATE: "Garantiens utløpsdato",
    },
    HEAD: {
      LEAVE: "Forlat",
      CREATE_NEW: "Start på nytt",
    },
    ENTRANCE: {
      POLICY: "Personvernpolicy",
      AGREE: "Klikk Godta for å starte samtalen",
    },
    MESSAGE: {
      WAIT: "Vennligst vent, vi ser etter en løsning for deg.",
    },
    END: "Samtalen avsluttet",
    END_MSG:
      "Vi er glade for å kunne tilby vår tjeneste. Ta gjerne kontakt for fremtidig støtte.",
    END_SURVEY: "Tilfredshetsundersøkelse",
    END_SURVEY_MSG:
      "Vi er glade for å kunne tilby vår tjeneste. Ta gjerne kontakt for fremtidig støtte.",
    BACKHOME: "Start samtalen på nytt",
    SURVEY: {
      DESC: "Vennligst vurder din opplevelse med ASUS' virtuelle assistent.",
      SAT: "Fornøyd",
      DISSAT: "Misfornøyd",
      FEEDBACK: "Vennligst fyll inn din tilbakemelding.",
      SEND: "Send",
      BACK: "Avbryt",
    },
    SURVEY_DISLIKE: {
      H1: "Hvorfor er du misfornøyd med svaret?",
      P: "Dine tilbakemeldinger hjelper oss med å forbedre vår servicekvalitet.",
      BUTTON: "Send",
    },
    HISTORY: {
      TITLE: "Historikk",
      AGO: "{hours} timer siden",
      CONTINUE: "Fortsett chatten",
      CLOSE: "Samtalen er avsluttet.",
      RESTART: "Start på nytt med virtuell assistent",
      NON_SERVICE: "Ikke-service timer",
      VIEW_HISTORY: "Klikk for å se den siste chattehistorikken.",
    },
  },
};
export default lan;